import React from 'react';
import PropTypes from 'prop-types';

import { TILE_MODES } from '@sm360/widget-commons-tiles';

// eslint-disable-next-line import/no-named-as-default
import CatalogTile from './Catalog/CatalogTile.jsx';
import InventoryUsedTile from './InventoryUsed/InventoryUsedTile.jsx';
import InventoryNewTile from './InventoryNew/InventoryNewTile.jsx';

const components = {
    [TILE_MODES.INVENTORY_USED]: InventoryUsedTile,
    [TILE_MODES.INVENTORY_NEW]: InventoryNewTile,
    [TILE_MODES.CATALOG]: CatalogTile,
};

function Tile({ mode, ...rest }) {
    const Component = components[mode];

    return <Component {...rest} />;
}

Tile.propTypes = {
    mode: PropTypes.string.isRequired,
};

Tile.displayName = 'Tile-A';

export default Tile;
